/* tslint:disable */

declare var Object: any;
export interface VendorRatingInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Owner"?: string;
  "Name"?: string;
  "Account__c"?: string;
  "Communication__c"?: string;
  "Communication_PGMO__c"?: string;
  "Job__c"?: string;
  "Overall_Rating__c"?: number;
  "Overall_Rating_Sec__c"?: number;
  "Professionalism__c"?: string;
  "Professionalism_PGMO__c"?: string;
  "Quality__c"?: string;
  "Quality_PGMO__c"?: string;
  "Review__c"?: string;
  "Review_PGMO__c"?: string;
  "Value__c"?: string;
  "Value_PGMO__c"?: string;
  "Worker_Arrival_On_Time__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class VendorRating implements VendorRatingInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Owner": string;
  "Name": string;
  "Account__c": string;
  "Communication__c": string;
  "Communication_PGMO__c": string;
  "Job__c": string;
  "Overall_Rating__c": number;
  "Overall_Rating_Sec__c": number;
  "Professionalism__c": string;
  "Professionalism_PGMO__c": string;
  "Quality__c": string;
  "Quality_PGMO__c": string;
  "Review__c": string;
  "Review_PGMO__c": string;
  "Value__c": string;
  "Value_PGMO__c": string;
  "Worker_Arrival_On_Time__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: VendorRatingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VendorRating`.
   */
  public static getModelName() {
    return "VendorRating";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VendorRating for dynamic purposes.
  **/
  public static factory(data: VendorRatingInterface): VendorRating{
    return new VendorRating(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VendorRating',
      plural: 'VendorRatings',
      path: 'VendorRatings',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Owner": {
          name: 'Owner',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Account__c": {
          name: 'Account__c',
          type: 'string'
        },
        "Communication__c": {
          name: 'Communication__c',
          type: 'string'
        },
        "Communication_PGMO__c": {
          name: 'Communication_PGMO__c',
          type: 'string'
        },
        "Job__c": {
          name: 'Job__c',
          type: 'string'
        },
        "Overall_Rating__c": {
          name: 'Overall_Rating__c',
          type: 'number'
        },
        "Overall_Rating_Sec__c": {
          name: 'Overall_Rating_Sec__c',
          type: 'number'
        },
        "Professionalism__c": {
          name: 'Professionalism__c',
          type: 'string'
        },
        "Professionalism_PGMO__c": {
          name: 'Professionalism_PGMO__c',
          type: 'string'
        },
        "Quality__c": {
          name: 'Quality__c',
          type: 'string'
        },
        "Quality_PGMO__c": {
          name: 'Quality_PGMO__c',
          type: 'string'
        },
        "Review__c": {
          name: 'Review__c',
          type: 'string'
        },
        "Review_PGMO__c": {
          name: 'Review_PGMO__c',
          type: 'string'
        },
        "Value__c": {
          name: 'Value__c',
          type: 'string'
        },
        "Value_PGMO__c": {
          name: 'Value_PGMO__c',
          type: 'string'
        },
        "Worker_Arrival_On_Time__c": {
          name: 'Worker_Arrival_On_Time__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
